import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconTrendingUp = createIcon({
  displayName: 'IconTrendingUp',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M20 14H22V6H14V8H20V14ZM16.5891 9.99984H17.9991V11.4098L12.9991 16.4098L8.49906 11.9098L2.70906 17.7098L1.28906 16.2898L8.49906 9.08984L12.9991 13.5898L16.5891 9.99984Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
